import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a fan icon
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <FanIcon width={12} />
 */
const FanIcon = props => (
    <SvgIcon {...props}>
        <path
            d="M30.45,21.17a5.58,5.58,0,0,1,3.08.06,10.41,10.41,0,0,0,2.3.32,6,6,0,0,
            0,3.2-.94A6.32,6.32,0,0,0,42,16,7.43,7.43,0,0,0,39.62,9.8,9.28,9.28,0,0,
            0,33,7.07a9.54,9.54,0,0,0-6.79,2.82,13.83,13.83,0,0,0-3.78,9.23,3.31,3.31,
            0,0,1-1.27-1.58,5.24,5.24,0,0,1,.06-3.08A6.7,6.7,0,0,0,20.62,9a6.36,6.36,
            0,0,0-5.44-3A7.66,7.66,0,0,0,9.8,8.38a9.48,9.48,0,0,0,.1,13.4,14,14,0,0,0,
            9.22,3.8,3.3,3.3,0,0,1-1.57,1.25,5.54,5.54,0,0,1-3.08-.06,10.41,10.41,0,0,
            0-2.3-.32,6,6,0,0,0-3.2.94A6.32,6.32,0,0,0,6,32,7.43,7.43,0,0,0,8.38,38.2,
            9.28,9.28,0,0,0,15,40.93a9.54,9.54,0,0,0,6.79-2.82,13.84,13.84,0,0,0,3.78-9.23,
            3.32,3.32,0,0,1,1.27,1.58,5.24,5.24,0,0,1-.06,3.08,6.7,6.7,0,0,0,.61,5.5,
            6.36,6.36,0,0,0,5.44,3,7.66,7.66,0,0,0,5.38-2.38,9.49,9.49,0,0,0-.1-13.4,
            14,14,0,0,0-9.22-3.8A3.3,3.3,0,0,1,30.45,21.17Zm-4.92,4.36a2.23,2.23,0,0,
            1-3.07,0A2.17,2.17,0,1,1,25.54,25.54Z"
        />
    </SvgIcon>
)

FanIcon.defaultProps = defaultProps

export { FanIcon }
